import React from "react";
import "./footer.scss";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mz-footer">
      <div className="mz-wrap mz-footer__inner">
        <div className="mz-footer__top">
          <div className="mz-footer__brand">
            <img
              className="mz-footer__logo"
              src="/assets/figma/logo-dark.svg?v=2"
              alt="Mezada"
              width="180.893"
              height="28"
            />
            <p className="mz-footer__tag">
              The best way to predict the future is to invent it.
            </p>
            <p className="mz-footer__sub">The company behind Joni.</p>
          </div>
          <div className="mz-footer__cols">
            <nav className="mz-footer__nav">
              <p className="mz-footer__nav-label">NAV</p>
              <HashLink to="/#home">Home</HashLink>
              <HashLink to="/#specialties">Specialties</HashLink>
              <HashLink to="/#product">Product</HashLink>
              <HashLink to="/#contact">Contact</HashLink>
            </nav>
            {/* <nav className="mz-footer__nav">
              <p className="mz-footer__nav-label">CONNECT</p>
              <a
                href="https://www.linkedin.com/company/mezadadev"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            </nav> */}
          </div>
        </div>
        <div className="mz-footer__rule" />
        <div className="mz-footer__bottom">
          <p className="mz-footer__copy">
            Copyright © 2026 Mezada Development and Software LTD. All rights reserved.
          </p>
          <div className="mz-footer__legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>
        <div className="mz-footer__mark" aria-hidden="true">
          <img
            className="mz-footer__mark-desktop"
            src="/assets/figma/watermark.svg?v=2"
            alt=""
          />
          <img
            className="mz-footer__mark-mobile"
            src="/assets/figma/watermark-mobile.svg?v=2"
            alt=""
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
